var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup56(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.657,
    height: 64.413,
    viewBox: "0 0 175.657 64.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 55.389,
    height: 64.102,
    transform: "translate(687.291 1133.857)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(368.834 -2133.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1056.125 999.996)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M735.99,1165.908a38.814,38.814,0,0,0,6.69,21.938,32.051,32.051,0,1,1,0-43.876,38.814,38.814,0,0,0-6.69,21.938"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M791.69,1165.908a38.814,38.814,0,0,0,6.69,21.938,31.985,31.985,0,0,1-46.676,0,22.771,22.771,0,0,1-2.489-2.957,25.566,25.566,0,0,1-2.178-3.422,31.506,31.506,0,0,1-4.046-15.715,33.207,33.207,0,0,1,4.046-15.714,25.577,25.577,0,0,1,2.178-3.423,22.827,22.827,0,0,1,2.489-2.956,31.985,31.985,0,0,1,46.676,0,41.885,41.885,0,0,0-6.69,22.249",
    transform: "translate(-1056.125 999.996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M862.948,1165.908a32.031,32.031,0,0,1-55.389,21.938,22.771,22.771,0,0,1-2.489-2.957,25.559,25.559,0,0,1-2.178-3.422,31.505,31.505,0,0,1-4.046-15.715,33.207,33.207,0,0,1,4.046-15.714,25.571,25.571,0,0,1,2.178-3.423,22.827,22.827,0,0,1,2.489-2.956,32.076,32.076,0,0,1,23.338-10.113,32.473,32.473,0,0,1,32.051,32.362",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup56);
export default __webpack_public_path__ + "static/media/Group 56.36fe2503cc67df91b737538cb6060072.svg";
export { ForwardRef as ReactComponent };